import React from 'react';
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { StyledTag, StyledLabel, StyledButton, StyledIcon, iconSizes, } from './Tag.styles';
const Icon = ({ size }) => {
    const d = size === 'small'
        ? 'M1.0014359,9.04102564 L9.03958974,1 M1,1.0014359 L9.04102564,9.03958974'
        : 'M1.00215385,13.0615384 L13.0593846,1 M1,1.00215385 L13.0615384,13.0593846';
    return (React.createElement(StyledIcon, { ...{
            width: iconSizes[size],
            height: iconSizes[size],
            viewBox: `0 0 ${iconSizes[size]} ${iconSizes[size]}`,
            version: '1.1',
            xmlns: 'http://www.w3.org/2000/svg',
            ariaHidden: 'true',
        } },
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: d, stroke: "currentColor" }))));
};
export const Tag = React.forwardRef(function Tag({ children, label, size = 'large', removable = false, role, onRemove, ...restProps }, ref) {
    const { tag: locale } = useLocale();
    const tagProps = {
        removable,
        role,
        size,
        ref,
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    return (React.createElement(StyledTag, { ...tagProps },
        React.createElement(StyledLabel, { size: size }, label),
        removable && (React.createElement(StyledButton, { "aria-label": `${locale.removeLabel} ${label}`, size: size, onClick: onRemove },
            React.createElement(Icon, { size: size })))));
});
//# sourceMappingURL=Tag.js.map